<template>
  <transition name="session-alert-fade">
    <div v-if="show" class="session-alert-overlay" @click.self="dismiss">
      <div class="session-alert-box" :class="{ 'sa-dark': isDark }">
        <div class="sa-icon">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="1.5"
            stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"/>
            <line x1="12" y1="8" x2="12" y2="12"/>
            <line x1="12" y1="16" x2="12.01" y2="16"/>
          </svg>
        </div>
        <h3 class="sa-title">Session Ended</h3>
        <p class="sa-message">{{ message }}</p>
        <button class="sa-btn" @click="dismiss">OK</button>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'SessionAlert',
  props: {
    visible: { type: Boolean, default: false },
    message: { type: String, default: '' }
  },
  data() {
    // visible only seeds the initial open state; the instance that
    // imperatively mounts this component (session_alert.js) toggles
    // dismissal by calling dismiss()/emitting, not by writing back to
    // the prop (props are read-only, and Vue 3's strict-mode reactive
    // proxy throws instead of warning on that).
    return { show: this.visible };
  },
  computed: {
    isDark() {
      return document.body.classList.contains('theme-dark') ||
        document.querySelector('.chart-page-dark') !== null;
    }
  },
  methods: {
    dismiss() {
      this.show = false;
      this.$emit('dismiss');
    }
  }
};
</script>

<style>
.session-alert-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 99999;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(2px);
}

.session-alert-box {
  background: #ffffff;
  border-radius: 16px;
  padding: 32px 36px;
  max-width: 380px;
  width: 90%;
  text-align: center;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15), 0 4px 16px rgba(0, 0, 0, 0.1);
  animation: sa-pop 0.25s ease-out;
}

.session-alert-box.sa-dark {
  background: #1e2436;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5), 0 4px 16px rgba(0, 0, 0, 0.3);
}

@keyframes sa-pop {
  from {
    opacity: 0;
    transform: scale(0.9) translateY(10px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

.sa-icon {
  color: #e54150;
  margin-bottom: 16px;
}

.sa-dark .sa-icon {
  color: #ef5350;
}

.sa-title {
  margin: 0 0 10px;
  font-size: 18px;
  font-weight: 700;
  color: #131722;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.sa-dark .sa-title {
  color: #e1e3e8;
}

.sa-message {
  margin: 0 0 24px;
  font-size: 14px;
  line-height: 1.5;
  color: #555;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.sa-dark .sa-message {
  color: #9ba2b0;
}

.sa-btn {
  display: inline-block;
  padding: 10px 40px;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  background: #2962ff;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.15s, transform 0.1s;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.sa-btn:hover {
  background: #1b4fd4;
}

.sa-btn:active {
  transform: scale(0.97);
}

.sa-dark .sa-btn {
  background: #5b9cf6;
}

.sa-dark .sa-btn:hover {
  background: #4a8ae0;
}

/* Transition */
.session-alert-fade-enter-active,
.session-alert-fade-leave-active {
  transition: opacity 0.2s ease;
}
.session-alert-fade-enter,
.session-alert-fade-leave-to {
  opacity: 0;
}
</style>
